/**
 * !!!!!请注意，如果组件之间有依赖关系，例如A组件使用了B组件
 * 务必把被依赖的组件的import放在前面，即先import B再import A
 */
import FitWxPhonex from './packages/wx-phonex';
import FitButton from './packages/button';
import FitIcon from './packages/icon';
import FitInput from './packages/input';
import FitDialog, { DialogButtonItem } from './packages/dialog';
import FitForm from './packages/form';
import FitFormItem from './packages/form-item';
import FitHalfScreenDialog from './packages/half-screen-dialog';
import FitHalfScreenOption from './packages/half-screen-option';
import FitPicker from './packages/picker';
import FitToast from './packages/toast';
import FitSelectItem from './packages/select/src/select-item.vue';
import FitSelect from './packages/select';
import FitLayout from './packages/layout';
import FitCorner from './packages/corner';
import FitDatePicker from './packages/date-picker';
import FitResult from './packages/result';
import FitLoadMore from './packages/load-more';
import FitNation from './packages/nation';
import FitNationList from './packages/nation-list';
import FitCheckbox from './packages/checkbox';
import FitBg from './packages/bg';
import FitTest from './packages/test';
import FitNavbar from './packages/navbar';
import FitNavbarItem from './packages/navbar-item';
import FitSwitch from './packages/switch';
import FitNumberBox from './packages/number-box';
import FitCard from './packages/card';
import FitTag from './packages/tag';
import FitPassword from './packages/password';
import FitKeyboard from './packages/keyboard';
import FitVerifyPwdPage from './packages/verify-pwd-page';
import FitTips from './packages/tips';
import FitInfoBox from './packages/info-box';
import FitInfoBoxItem from './packages/info-box/src/item.vue';
import FitOperationBanner from './packages/operation-banner';
import FitBadge from './packages/badge';
import FitMsg from './packages/msg';
import FitDrag from './packages/drag';
import ScreenDialog from './packages/screen-dialog';
import FitHalfScreenDialogV2 from './packages/half-screen-dialog-v2';
import NavTabs, { NavTabsInfo } from './packages/nav-tabs';
import Notice, { NoticeProps } from './packages/notice';
import FitPwdConfirm from './packages/pwd-confirm';
import AmountInput from './packages/amount-input';
import AmountBox from './packages/amount-box';
import KeyboardInput from './packages/keyboard-input';


const compoentsMap = {
  FitIcon,
  FitInput,
  FitButton,
  FitVerifyPwdPage,
  FitDialog,
  FitForm,
  FitFormItem,
  FitHalfScreenDialog,
  FitHalfScreenOption,
  FitPicker,
  FitToast,
  FitSelect,
  FitLayout,
  FitCorner,
  FitDatePicker,
  FitResult,
  FitLoadMore,
  FitNation,
  FitCheckbox,
  FitBg,
  FitTest,
  FitNavbar,
  FitNavbarItem,
  FitSwitch,
  FitNumberBox,
  FitCard,
  FitTag,
  FitSelectItem,
  FitPassword,
  FitKeyboard,
  FitTips,
  FitWxPhonex,
  FitInfoBox,
  FitInfoBoxItem,
  FitOperationBanner,
  FitBadge,
  FitMsg,
  FitDrag,
  ScreenDialog,
  FitHalfScreenDialogV2,
  Notice,
  NavTabs,
  AmountInput,
  AmountBox,
  KeyboardInput,
};

function install(Vue: any) {
  Object.keys(compoentsMap).forEach((conponentName) => {
    Vue.component(conponentName, compoentsMap[conponentName].options);
  });
}

export default Object.assign({ install }, compoentsMap);

export {
  FitIcon,
  FitInput,
  FitButton,
  FitVerifyPwdPage,
  FitDialog,
  FitForm,
  FitFormItem,
  FitHalfScreenDialog,
  FitHalfScreenOption,
  FitToast,
  FitSelect,
  FitLayout,
  FitCorner,
  FitDatePicker,
  FitPicker,
  FitResult,
  FitLoadMore,
  FitNation,
  FitNationList,
  FitCheckbox,
  FitBg,
  FitTest,
  FitNavbar,
  FitNavbarItem,
  FitSwitch,
  FitNumberBox,
  FitCard,
  FitTag,
  FitSelectItem,
  FitPassword,
  FitKeyboard,
  FitTips,
  FitWxPhonex,
  FitInfoBox,
  FitInfoBoxItem,
  FitOperationBanner,
  FitBadge,
  FitMsg,
  FitDrag,
  ScreenDialog,
  FitHalfScreenDialogV2,
  FitPwdConfirm,
};

export { Notice };
export type { NoticeProps  };

export { NavTabs };
export type { NavTabsInfo };

export type { DialogButtonItem };

export { AmountInput };

export { AmountBox  };

export { KeyboardInput };
